import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { environment } from 'environments/environment';
import { Store } from '@ngrx/store';
import { showErrorNotification } from 'app/store/actions/view.actions';
import { MESSAGES } from '@constants/messages.constants';
import {
  FILE_DOWNLOADER_TYPE_BUTTON,
  FILE_DOWNLOADER_TYPE_LINK,
  FileDownloaderType,
} from '@app-types/file_downloader.types';

/**
 * Component to download file by id
 * @export
 * @class MolFileDownloaderComponent
 */
@Component({
  selector: 'mol-file-downloader',
  templateUrl: './mol-file-downloader.component.html',
  styleUrls: ['./mol-file-downloader.component.scss'],
})
export class MolFileDownloaderComponent {
  /**
   * Label to display when the file downloader is disabled
   * @type {string}
   * @default MESSAGES.FILE_DOWNLOADER.DOCUMENT_NOT_AVAILABLE
   */
  @Input() disabledLabel: string = MESSAGES.FILE_DOWNLOADER.DOCUMENT_NOT_AVAILABLE;

  /**
   * Id of the file to download
   * @type {string}
   */
  @Input() fileId = '';

  /**
   * File name of the file to download
   * @type {string}
   */
  @Input() fileName = '';

  /**
   * Flag to enable or disable the file downloader
   * @type {boolean}
   * @default true
   */
  @Input() isEnabled = true;

  /**
   * Display type for the file downloader
   * @type {FileDownloaderType}
   * @default FILE_DOWNLOADER_TYPE_BUTTON
   */
  @Input() type: FileDownloaderType = FILE_DOWNLOADER_TYPE_BUTTON;

  /**
   * Constant exposed to template for button type comparison
   * @readonly
   * @type {string}
   */
  readonly FILE_DOWNLOADER_TYPE_BUTTON = FILE_DOWNLOADER_TYPE_BUTTON;

  /**
   * Constant exposed to template for link type comparison
   * @readonly
   * @type {string}
   */
  readonly FILE_DOWNLOADER_TYPE_LINK = FILE_DOWNLOADER_TYPE_LINK;

  /**
   * API base path
   * @private
   * @type {string}
   */
  private apiPath: string = environment.apiUrl;

  /**
   * Creates an instance of MolFileDownloaderComponent.
   * @param {HttpClient} http
   * @param {Store} store
   */
  constructor(
    private http: HttpClient,
    private store: Store
  ) {}

  /**
   * Method to download file
   */
  downloadFile() {
    const downloadUrl = `${this.apiPath}/FileDownload/${this.fileId}`;

    this.http.get(downloadUrl, { responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      () => {
        this.store.dispatch(
          showErrorNotification({
            message: MESSAGES.FILE_DOWNLOADER.DOWNLOAD_ERROR,
          })
        );
      }
    );
  }
}
